import React from "react";
import { Box, Typography, CardContent, LinearProgress } from "@mui/material";
import { StyledCard } from "../../common/StyledCard";
import { getEntityMeta } from "../../../helpers/dashboardHelpers";
import { UserStatsDto } from "../../../shared/dtos/user/UserStatsDto";

interface UserStatusWidgetProps {
  data: UserStatsDto;
}

const UserStatusWidget: React.FC<UserStatusWidgetProps> = ({ data }) => {
  const meta = getEntityMeta("USER");
  const Icon = meta.icon;

  const statuses = [
    { label: "Active", value: data.active, color: "success" as const },
    { label: "Pending", value: data.pending, color: "warning" as const },
    { label: "Inactive", value: data.inactive, color: "inherit" as const },
    { label: "Locked", value: data.locked, color: "error" as const },
  ];

  return (
    <StyledCard sx={{ height: "100%" }}>
      <CardContent>
        <Box sx={{ display: "flex", alignItems: "center", mb: 3 }}>
          <Box
            sx={{
              p: 1,
              borderRadius: 1,
              bgcolor: `${meta.color}15`,
              color: meta.color,
              display: "flex",
              mr: 2,
            }}
          >
            <Icon />
          </Box>
          <Box>
            <Typography variant="h6" sx={{ fontWeight: "bold" }}>
              System Users
            </Typography>
            <Typography variant="body2" sx={{ color: "text.secondary" }}>
              Total Accounts: {data.total}
            </Typography>
          </Box>
        </Box>

        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          {statuses.map((s, index) => (
            <Box key={index}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  mb: 0.5,
                }}
              >
                <Typography variant="body2">{s.label}</Typography>
                <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                  {s.value}
                </Typography>
              </Box>
              <LinearProgress
                variant="determinate"
                value={(s.value / (data.total || 1)) * 100}
                color={s.color}
                sx={{ height: 6, borderRadius: 3 }}
              />
            </Box>
          ))}
        </Box>
      </CardContent>
    </StyledCard>
  );
};
export default UserStatusWidget;
